import axios from "axios";
import Swal from "sweetalert2";

export function scrollToSection(id) {
  const Section = document.getElementById(id);
  Section.scrollIntoView({ behavior: "smooth" });
}

// export function walletConnected(address) {
//   if (address) {
//     const data = {
//       walletAddress: address,
//       bindedAddress: "",
//       fTwitter: false,
//       tTwitter: false,
//       fDiscord: false,
//       fTelegram: false,
//       shear: 0,
//       fInstagram: false,
//       Youtube: false,
//       Retweet: false,
//     };
//     axios.post("http://localhost:8080/user", data)
//       .then((response) => {
//         // console.log("Success:", response.data);
//         return response.data;
//       })
//       .catch((error) => {
//         console.error("Error:", error);
//       });
//   }
// }

// export function getUser(address) {
//     if (address) {
//       axios.get(`http://localhost:8080/user${address}`)
//         .then((response) => {
//           return response.data.user;
//         })
//         .catch((error) => {
//           console.error("Error:", error);
//         });
//     }
// }

export function bindAddress(address) {
  const input = document.getElementById('bind').value
  const regix = /^0x[a-fA-F0-9]{40}$/
  
  if(regix.test(input)){
    const data = {
      walletAddress: address,
      section: "bindedAddress",
      value: address,
    };
    axios
      .put("http://localhost:8080/userUpdate", data)
      .then((response) => {
        console.log("Success:", response.data);
        window.location.reload()
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }else{
    Swal.fire(
      'Address is Not Valid'
    )
  }
}

export function followOnTwitter(address) {
  const data = {
    walletAddress: address,
    section: "fTwitter",
    value: true,
  };
  axios
    .put("http://localhost:8080/userUpdate", data)
    .then((response) => {
      console.log("Success:", response.data);
      window.location.reload()
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

export function tweetOnTwitter(address) {
  const data = {
    walletAddress: address,
    section: "tTwitter",
    value: true,
  };
  axios
    .put("http://localhost:8080/userUpdate", data)
    .then((response) => {
      console.log("Success:", response.data);
      window.location.reload()
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

export function joinDiscord(address) {
  const data = {
    walletAddress: address,
    section: "fDiscord",
    value: true,
  };
  axios
    .put("http://localhost:8080/userUpdate", data)
    .then((response) => {
      console.log("Success:", response.data);
      window.location.reload()
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

export function joinTelegram(address) {
  const data = {
    walletAddress: address,
    section: "fTelegram",
    value: true,
  };
  axios
    .put("http://localhost:8080/userUpdate", data)
    .then((response) => {
      console.log("Success:", response.data);
      window.location.reload()
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

export function shearWithfriends(address) {
  const data = {
    walletAddress: address,
    section: "shear",
    value: 1,
  };
  axios
    .put("http://localhost:8080/userUpdate", data)
    .then((response) => {
      console.log("Success:", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

export function followOnInsta(address) {
  const data = {
    walletAddress: address,
    section: "fInstagram",
    value: true,
  };
  axios
    .put("http://localhost:8080/userUpdate", data)
    .then((response) => {
      console.log("Success:", response.data);
      window.location.reload()
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

export function followOnYoutube(address) {
  const data = {
    walletAddress: address,
    section: "Youtube",
    value: true,
  };
  axios
    .put("http://localhost:8080/userUpdate", data)
    .then((response) => {
      console.log("Success:", response.data);
      window.location.reload()
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

export function retweet(address) {
  const data = {
    walletAddress: address,
    section: "Retweet",
    value: true,
  };
  axios
    .put("http://localhost:8080/userUpdate", data)
    .then((response) => {
      console.log("Success:", response.data);
      window.location.reload()
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}
